import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import Button from '../../../../components/common/Button';
import Radio from '../../../../components/common/Radio';
import {
  getHousingFundsCheck,
  getHousingFundsCheckSave,
  resetCheckList,
} from '../housingFundsSlice';
import { formatNumber, getAlertMessageFunction, magamCertifyCheck } from '../../../../common/Util';
import Typography from '../../../../components/common/Typography';
import { calculateInitialDisplay02, handleDisplayKey02 } from '../util';
import TextField from '../../../../components/common/TextField';
import SlideRightDialog from '../../../../components/common/SlideRightDialog';

// 장기주택저당차입금 공제요건 체크 컴포넌트
const Type2 = ({ onClose, isOpen, onOpen, document }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t: tCommon } = useTranslation('common');
  const { checkList1, salary } = useSelector(state => state.housingFunds);
  const { isMagam, isCertify } = useSelector(state => state.common);
  const [checkList, setCheckList] = useState([]);
  const [displayKeys, setDisplayKeys] = useState(['1', '3', '6', '7', '9', '10', '11', '13']);
  const [alertToShow, setAlertToShow] = useState(null);

  useEffect(() => {
    if (isOpen) {
      dispatch(getHousingFundsCheck({ hInType: '2' }));
    }

    return () => {
      dispatch(resetCheckList());
    };
  }, [dispatch, isOpen]);

  // 초기 displayKeys 설정을 위한 useEffect
  useEffect(() => {
    if (checkList1) {
      setCheckList(checkList1);
      const initialDisplayKeys = calculateInitialDisplay02(checkList1, salary);
      setDisplayKeys(initialDisplayKeys);
    }
  }, [checkList1, salary]);

  useEffect(() => {
    const alertMessage = getAlertMessageFunction();
    if (alertToShow) {
      alertMessage(alertToShow);
      setAlertToShow(null); // 알림 표시 후 상태 초기화
    }
  }, [alertToShow]);

  // 라디오 버튼 변경 핸들러
  const handleRadioChange = (htmSeq, value) => {
    setCheckList(prevList => {
      const {
        newList,
        newDisplayKeys,
        alertToShow: newAlert,
      } = handleDisplayKey02(prevList, displayKeys, salary, htmSeq, value);

      console.log('newDisplayKeys', newDisplayKeys);
      console.log('newList', newList);
      setDisplayKeys(newDisplayKeys);

      if (newAlert) {
        setAlertToShow(newAlert);
      }

      return newList;
    });
  };

  // 제출 핸들러
  const handleSubmit = () => {
    if (!magamCertifyCheck(isMagam, isCertify)) {
      return;
    }

    const alertMessage = getAlertMessageFunction();

    console.log('displayKeys>>', displayKeys);

    // 현재 display 상태인 항목들 체크
    const isAllChecked = displayKeys.every(
      key => checkList.find(item => item.htmSeq === key)?.htmValue != null,
    );

    // 5천만원 이상일때 로직 한번더 확인
    const error = checkList.find(item => {
      if (item.htmAlert) {
        if (item.htmSeq === '2' || item.htmSeq === '12') {
          console.log('item.key ==', item.key);
          return checkList.find(i => i.htmSeq === item.htmSeq)?.htmValue === '1';
        } else {
          console.log('item.key ==', item.key);
          return checkList.find(i => i.htmSeq === item.htmSeq)?.htmValue === '2';
        }
      }
      return false;
    });

    console.log('error', error);

    let result = true;
    if (!isAllChecked || error !== undefined) {
      alertMessage('공제요건이 맞지 않아 공제가 불가능합니다.');
      result = false;
    }
    saveApi(result);
  };

  const saveApi = async result => {
    const alertMessage = getAlertMessageFunction();
    console.log('result', result);
    let setData = { cmd: 'S1010EA', flag: result ? 'ok' : '', hInType: '2', htmCnt: 15 };
    checkList.forEach(item => {
      let key = '';
      if (Number(item.htmSeq) >= 10) key = 'htm0' + item.htmSeq + 'S';
      else key = 'htm00' + item.htmSeq + 'S';

      if (item.htmSeq == '15') {
        setData.htm015_2 = item.htmValue2 || '';
      }

      setData[key] = item.htmValue || '';
    });

    try {
      const response = await dispatch(getHousingFundsCheckSave(setData)).unwrap();
      if (response.resultCode === 'OK') {
        if (result) {
          alertMessage(tCommon('alertMessage.saveSuccess'));
          if (document) {
            onClose();
          } else {
            onOpen('type2', 'detail');
          }
        }
      } else {
        alertMessage(tCommon('alertMessage.saveFail'));
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  const handleHtm015Change = e => {
    const { name, value } = e.target;
    const sanitizedValue = value.replace(/,/g, '');

    setCheckList(prevList => {
      const newList = prevList.map(item => {
        if (name === 'htm015S' && item.htmSeq === '15') {
          return { ...item, htmValue: sanitizedValue };
        } else if (name == 'htm015_2' && item.htmSeq === '15') {
          return { ...item, htmValue2: sanitizedValue };
        }
        return item;
      });

      return newList;
    });
  };

  const radioButton = (htmSeq, isCheckedYes, isCheckedNo, item) => {
    if (htmSeq != '15') {
      return (
        <div className="displayFlex" style={{ gap: '40px', justifyContent: 'flex-end' }}>
          <Radio
            name={`htm${htmSeq.toString().padStart(3, '0')}S`}
            value="1"
            checked={isCheckedYes}
            onChange={() => handleRadioChange(htmSeq, '1')}
            label={tCommon('radioGroup.yes')}
          />
          <Radio
            name={`htm${htmSeq.toString().padStart(3, '0')}S`}
            value="2"
            checked={isCheckedNo}
            onChange={() => handleRadioChange(htmSeq, '2')}
            label={tCommon('radioGroup.no')}
          />
        </div>
      );
    } else {
      return (
        <div className="displayFlex" style={{ gap: '20px', justifyContent: 'flex-end' }}>
          <div className="displayFlex" style={{ gap: '8px', flex: 1 }}>
            <Typography variant="body2Medium" style={{ flex: 1 }}>
              전 :
            </Typography>
            <TextField
              size="small"
              style={{ flex: 3 }}
              value={formatNumber(item?.htmValue?.replace(/,/g, ''))}
              name="htm015S"
              onChange={handleHtm015Change}
            />
          </div>
          <div className="displayFlex" style={{ gap: '8px', flex: 1 }}>
            <Typography variant="body2Medium" style={{ flex: 1 }}>
              후 :
            </Typography>
            <TextField
              size="small"
              style={{ flex: 3 }}
              value={formatNumber(item?.htmValue2?.replace(/,/g, ''))}
              name="htm015_2"
              onChange={handleHtm015Change}
            />
          </div>
        </div>
      );
    }
  };

  return (
    <SlideRightDialog onClose={onClose} isOpen={isOpen}>
      <div className="displayFlexColumn" style={{ gap: '16px' }}>
        {checkList
          .filter(item => displayKeys.includes(item.htmSeq))
          .map(item => {
            const isCheckedYes = item.htmValue === '1';
            const isCheckedNo = item.htmValue === '2';

            return (
              <div
                className="displayFlexColumn"
                key={item.htmSeq}
                id={`t${item.htmSeq}`}
                style={{ gap: '16px' }}>
                <Typography variant="body2Medium" style={{ whiteSpace: 'pre-wrap' }}>
                  {item.htmText}
                </Typography>
                {radioButton(item.htmSeq, isCheckedYes, isCheckedNo, item)}
                {/* <div className="displayFlex" style={{ gap: '40px', justifyContent: 'flex-end' }}>
                <Radio
                  name={`htm${item.htmSeq.toString().padStart(3, '0')}S`}
                  value="1"
                  checked={isCheckedYes}
                  onChange={() => handleRadioChange(item.htmSeq, '1')}
                  label="예"
                />
                <Radio
                  name={`htm${item.htmSeq.toString().padStart(3, '0')}S`}
                  value="2"
                  checked={isCheckedNo}
                  onChange={() => handleRadioChange(item.htmSeq, '2')}
                  label="아니오"
                />
              </div> */}
              </div>
            );
          })}

        <Button value={tCommon('housingFundsCheckList.button1')} fullWidth onClick={handleSubmit} />
      </div>
    </SlideRightDialog>
  );
};

export default Type2;
